import { render } from "./ColourFamilySwatches.vue?vue&type=template&id=01aaa6c3&scoped=true"
import script from "./ColourFamilySwatches.vue?vue&type=script&lang=js"
export * from "./ColourFamilySwatches.vue?vue&type=script&lang=js"

import "./ColourFamilySwatches.vue?vue&type=style&index=0&id=01aaa6c3&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01aaa6c3"]])

export default __exports__